export default __webpack_public_path__ + "static/media/2259.d9ff652f.png";